export default __webpack_public_path__ + "img/176d2198e31288ef0859e3ea87d0956a.png";